var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 10C18.125 14.4873 14.4873 18.125 10 18.125M18.125 10C18.125 5.51269 14.4873 1.875 10 1.875M18.125 10H1.875M10 18.125C5.51269 18.125 1.875 14.4873 1.875 10M10 18.125C11.7259 18.125 13.125 14.4873 13.125 10C13.125 5.51269 11.7259 1.875 10 1.875M10 18.125C8.27411 18.125 6.875 14.4873 6.875 10C6.875 5.51269 8.27411 1.875 10 1.875M1.875 10C1.875 5.51269 5.51269 1.875 10 1.875",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.914f8d31249d9173783a688aaa76e4e5.svg";
export { ForwardRef as ReactComponent };